module.exports = __webpack_public_path__ + "img/expectation.616ad01e.png";